import React, { useEffect, useRef } from "react";
import i18next from "i18next";

// Replaces %placeholder% markers in server-provided HTML with React components.
// Template HTML is trusted (generated by Claude API). User data inside the
// template is sanitized by the backend before being embedded.
export default function ConfTemplateRenderer({ html, onTicketClick }) {
  const containerRef = useRef(null);

  const processHtml = (rawHtml) => {
    let processed = rawHtml;
    const buyBtn = `<button class="btn-gradient" data-ph="buy_ticket">${i18next.t("tiket_get")}</button>`;
    const myBtn = `<button class="btn-gradient" data-ph="my_ticket">${i18next.t("show_ticket")}</button>`;
    processed = processed.replace(/%buy_ticket%/g, buyBtn);
    processed = processed.replace(/%my_ticket%/g, myBtn);
    return processed;
  };

  const processedHtml = processHtml(html);

  // Handle clicks on placeholder buttons and execute scripts
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Handle clicks on placeholder buttons
    const handleClick = (e) => {
      const btn = e.target.closest('[data-ph="buy_ticket"], [data-ph="my_ticket"]');
      if (btn && onTicketClick) {
        onTicketClick();
      }
    };

    container.addEventListener("click", handleClick);

    // Execute scripts found in the HTML
    const scripts = container.querySelectorAll("script");
    scripts.forEach((script) => {
      const newScript = document.createElement("script");
      if (script.src) {
        newScript.src = script.src;
      } else {
        newScript.textContent = script.textContent;
      }
      document.body.appendChild(newScript);
    });

    return () => {
      container.removeEventListener("click", handleClick);
      scripts.forEach((_, idx) => {
        const script = container.querySelector("script");
        if (script) {
          document.body.removeChild(script);
        }
      });
    };
  }, [onTicketClick]);

  return (
    <div
      ref={containerRef}
      dangerouslySetInnerHTML={{ __html: processedHtml }}
    />
  );
}
